let bodyPosition = 0;
const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

export const freezeBody = () => {
  const doc = document.documentElement;
  bodyPosition = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  // console.log('freezeBody() iOS:' + iOS + ', bodyPosition:' + bodyPosition);
  document.body.style.overflow = 'hidden';
  if (iOS) {
    document.body.style.position = 'fixed';
    document.body.style.left = '0';
    document.body.style.top = Math.abs(bodyPosition) * -1 + 'px';
    document.body.style.right = '0';
  }

};

export const unfreezeBody = () => {
  // console.log('unfreezeBody() iOS:' + iOS + ', bodyPosition:' + bodyPosition);
  document.body.style.overflow = 'auto';
  if (iOS) {
    document.body.style.position = 'static';
    window.scrollTo(0, bodyPosition);
    bodyPosition = 0;
  }
};
